import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8b854d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "water" }

import { ref, onMounted } from 'vue'
import * as echarts from 'echarts'
import 'echarts-liquidfill'


export default /*#__PURE__*/_defineComponent({
  __name: 'water',
  props: ['value', 'unit'],
  setup(__props) {

const props = __props

const instanceRef = ref()

onMounted(() => {
  init()
})

const init = () => {
  const chart = echarts.init(instanceRef.value)

  const formatter = (props.value || '-') + (props.unit || '')
  const option = {
    series: [
      {
        type: 'liquidFill',
        data: [-1, 0.5, 0.3, -1],
        color: ['#2D55AA', '#4579E2'],
        shape: 'container',
        outline: {
          show: false,
        },
        amplitude: 14,
        waveAnimation: 10,
        backgroundStyle: {
          color: '#8BADCB',
        },
        label: {
          position: ['50%', '50%'],
          formatter,
          fontSize: 16,
          color: '#fff',
        },
      },
    ],
  }
  chart.setOption(option)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "water-conatiner",
      ref_key: "instanceRef",
      ref: instanceRef
    }, null, 512)
  ]))
}
}

})